import React, { useEffect, useState } from "react";
import {
  adminBulkUpdateMFAStatus,
  adminBulkUpdateStatus,
  adminDeleteSpecificUser,
  adminGetUsers,
  adminResendInviteUsers,
  exportAdminUsers,
} from "@services/users.service";
import { getValue } from "@utils/lodash";
import "./user.scss";
import { NavLink } from "react-router-dom";
import moment from "moment";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { useNavigate } from "react-router-dom";
import SearchHeader from "@components/common/SearchHeader";
import PaginationPage from "@components/pagination/pagination";
import ScrollableReactTable from "@components/ScrollableDatatable";
import NavigationBar from "@components/NotificationBar";
import { toast } from "react-toastify";
import DeleteModal from "@_common/deleteModal";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { handleDownloadOnClick } from "@_common/downloadfile";
import MoreAdminSvgComponent from "../../../assets/svg-components/left-menu/more-admin";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
interface IAdminUsersProps {}

const AdminUsers: React.FunctionComponent<IAdminUsersProps> = (props: any) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [usersList, setUsersList] = React.useState<[]>([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let user: any = JSON.parse(getValue(localStorage, `user`, ""));
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: params.status,
      sort_by: params.sort_by,
      user_type: "CLIENT",
      org_id: getValue(user, `org_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setUsersList(
          getValue(resp, `data.users`, []).map((item: object) => ({
            ...item,
            createdAtFormatted: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY"
            ),
            last_signed_inFormatted: getValue(item, `last_signed_in`, "")
              ? moment(getValue(item, `last_signed_in`, "")).format(
                  "DD MMM YYYY"
                )
              : "",
            status: getValue(item, `is_active`, "") ? "Active" : "Inactive",
            mfa_modified: getValue(item, `is_mfa`, false) ? "Yes" : "No",
            permissions: getValue(item, `roles`, []).map(
              (item: any, index: number) => item.title + ", "
            ),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);

      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.status = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      usersList.length > 0
        ? usersList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    navigate(`/edit-user/${getValue(obj, `original.id`, "")}`);
  };
  const rowClickUpdate = () => {};
  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificUser(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/edit-user/${id}`);
  };
  const handleResendInvite = async (e: any, id: string) => {
    e.stopPropagation();
    try {
      let resp = await adminResendInviteUsers({
        ids: [id],
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        // getData();
      }
    } catch (error) {}
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "User ID",
        accessor: "email",
        width: 250,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`/edit-user/${row.original.id}`}>
              {row.values.email}
            </NavLink>
          );
        },
      },
      {
        Header: "First Name",
        accessor: "first_name",
        width: 250,
      },
      {
        Header: "Last Name",
        accessor: "last_name",
        width: 250,
      },
      {
        Header: "Roles",
        accessor: "permissions",
        width: 250,
      },
      {
        Header: "Added on",
        accessor: "createdAtFormatted",
        width: 250,
      },
      {
        Header: "Last Signed-in",
        accessor: "last_signed_inFormatted",
        width: 250,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 150,
      },
      {
        Header: "MFA",
        accessor: "mfa_modified",
        width: 150,
      },
      {
        Header: "Action",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            !row.original.is_verified && (
              <>
                <button
                  className="resend-btn"
                  onClick={(e) =>
                    handleResendInvite(e, getValue(row, `original.id`, ""))
                  }
                >
                  <img src="/images/resend.svg" className="img-fluid d-block" />
                  Resend
                </button>
              </>
            )
          );
        },
      },
    ],
    []
  );
  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const handleChangeMFAStatus = async (value: string) => {
    try {
      let resp = await adminBulkUpdateMFAStatus({
        ids: selectedIDs,
        is_mfa: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const handleNavigateUserEntity = () => {
    if (getValue(selectedIDs, `[${0}]`, "")) {
      navigate(
        `/admin/user/entity-mapping/${getValue(selectedIDs, `[${0}]`, "")}`
      );
    } else {
      toast.error("Please select User");
    }
  };

  const handleNavigateUserInternalEntity = () => {
    if (getValue(selectedIDs, `[${0}]`, "")) {
      navigate(
        `/admin/user/internal-mapping/${getValue(selectedIDs, `[${0}]`, "")}`
      );
    } else {
      toast.error("Please select User");
    }
  };
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    setDownloadLoading(true);
    try {
      let resp = await exportAdminUsers();
      if (resp) {
        setDownloadLoading(false);
        // toast.success(getValue(resp, `message`, ""));
        handleDownloadOnClick(getValue(resp, `data.downloadUrl`, ""), "Users");
        // navigate(`/self-compliance-logs/USER`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleNavigateLocation = () => {
    if (getValue(selectedIDs, `[${0}]`, "")) {
      navigate(
        `/admin/user/location-mapping/${getValue(selectedIDs, `[${0}]`, "")}`
      );
    } else {
      toast.error("Please select User");
    }
  };
  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "admin_general_user"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            {/* <div className="dashboard-wrapper__header">
              <h4 className="dashbaord-wrapper__header-title">Users</h4>
            </div> */}

            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreAdminSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Admin
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Users</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                
                //change owner
                
                // download section
                commonUpload
                commonViewLogs
                dropdownOptions={[
                  { value: "CLIENT_USER", label: "User Upload" },
                  { value: "USER_ENTITY_MAPPING", label: "User Entity Upload" },
                  { value: "LOCATION_CLIENT_USER_MAPPING", label: "User Location Upload" },
                ]}
                downloadSelfComplianceReport
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //Add
                route={"/add-user"}
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
                
                //Line Seperator of button
                lineSeperator={true}
              />
            </div>
          </div>
            {getValue(selectedIDs, `length`, 0) > 0 && (
              <NavigationBar
                selectedIDs={selectedIDs}
                isMarkInactiveSectionVisible={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleChangeActiveStatus={handleChangeActiveStatus}
                text={"Mark Inactive"}
                handleRemoveNavItems={handleRemoveNavItems}
                multi={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                mfa_multi={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleChangeMFAStatus={handleChangeMFAStatus}
                permissions={getValue(props, `permissions`, [])}
                entityMapping={
                  getValue(props, `products`, []).includes("SELFCOMP")
                    ? true
                    : false
                }
                handleNavigateUserEntity={handleNavigateUserEntity}
                internalMapping={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleNavigateUserInternalEntity={
                  handleNavigateUserInternalEntity
                }
                locationMapping
                handleNavigateLocation={handleNavigateLocation}
              />
            )}
            <div className={`main-page-layout-wrapper`} id={getValue(selectedIDs, `length`, 0) > 0
					? "blueNavigationVisible"
					: ""}>
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/add-user"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  add={
                    getValue(props, `permissions`, []).includes("create")
                      ? "true"
                      : "false"
                  }
                  commonUpload
                  commonViewLogs
                  dropdownOptions={[
                    { value: "CLIENT_USER", label: "User Upload" },
                    { value: "USER_ENTITY_MAPPING", label: "User Entity Upload" },
                  ]}
                  downloadSelfComplianceReport
                  handleDownloadSelfComplianceReport={
                    handleDownloadSelfComplianceReport
                  }
                  downloadLoading={downloadLoading}
                />
              </div>

              <div className="admin-wrapper">
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : usersList.length > 0 ? (
                  getValue(props, `permissions`, []).includes("update") ? (
                    <ScrollableReactTable
                      columns={columns}
                      data={usersList}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                    />
                  ) : (
                    <ScrollableReactTable
                      columns={columns}
                      data={usersList}
                      getTableState={getTableState}
                      rowClick={rowClickUpdate}
                      check={check}
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                    />
                  )
                ) : (
                  <>
                    <>
                      {Object.keys(params).length !== 0 ? (
                        <Notfound />
                      ) : (
                        <Notfound />
                      )}
                    </>
                  </>
                )}
              </div>
              <div className="footer-wrapper d-flex justify-content-between">
                {usersList.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
            </div>
            <DeleteModal
              isOpen={isDelete}
              handleModal={handleDelete}
              handleSubmit={handleDeleteFunction}
              deleteValue={deleteValue}
            />
          </>
        )}
      </DashboardLayout>{" "}
    </>
  );
};

export default AdminUsers;
